<template>
  <div class="product__gallery">
    <div class="product__gallery-main" @click="showLightbox(currentIndex)">
      <div v-if="badge" class="product__gallery-badge">{{ badge }}</div>
      <div v-if="artosBadge" class="product__gallery-artos-badge">
        <img :src="artosBadgeUrl" alt="Výrobek ARTOS">
      </div>
      <img :src="images[currentIndex].url" :alt="images[currentIndex].alt">
    </div>
    
    <div v-if="images.length > 1" class="product__gallery-thumbs">
      <div 
        v-for="(image, index) in images" 
        :key="index"
        class="product__gallery-thumb"
        :class="{ 'is-active': currentIndex === index }"
        @mouseenter="currentIndex = index"
        @click="showLightbox(index)"
      >
        <img :src="image.url" :alt="image.alt">
      </div>
    </div>

    <teleport to="body">
      <vue-easy-lightbox
        :visible="visible"
        :imgs="lightboxImages"
        :index="currentIndex"
        @hide="handleHide"
      ></vue-easy-lightbox>
    </teleport>
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'
import artosBadgeUrl from '/img/icons/badge_artos_product.svg?url'

export default {
  name: 'ProductGallery',
  
  components: {
    VueEasyLightbox
  },
  
  props: {
    images: {
      type: Array,
      required: true,
      // Expected format: [{ url: string, alt: string }]
    },
    badge: {
      type: String,
      default: ''
    },
    artosBadge: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      currentIndex: 0,
      visible: false,
      artosBadgeUrl
    }
  },
  
  computed: {
    lightboxImages() {
      return this.images.map(img => img.url)
    }
  },
  
  methods: {
    showLightbox(index) {
      this.currentIndex = index
      this.visible = true
    },
    
    handleHide() {
      this.visible = false
    }
  },
  
  mounted() {
    console.log('ProductGallery artosBadge:', this.artosBadge);
  }
}
</script> 